import SigninScreen from './signin';

const routes = [
  {
    path: '/signin',
    component: SigninScreen,
  }
];

export default routes;
